import { render } from "./sv-font-icon.vue?vue&type=template&id=04e507ad&ts=true"
import script from "./sv-font-icon?vue&type=script&lang=ts&external"
export * from "./sv-font-icon?vue&type=script&lang=ts&external"

import "./sv-font-icon.vue?vue&type=style&index=0&id=04e507ad&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__